
import {
  createMuiTheme,
  responsiveFontSizes
} from '@material-ui/core/styles'

import PoppinsFont from '@static/fonts/Poppins.ttf'

const poppins = {
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `local('Poppins'), url('${PoppinsFont}') format('truetype')`
};

const theme = responsiveFontSizes(createMuiTheme({
  typography: {
    fontFamily: 'Poppins'
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [poppins]
      }
    }
  },
  palette: {
    primary: {
      light: '#4791db',
      main: '#00a1c3',
      dark: '#115293',
      contrastText: '#ffffff'
    },
    secondary: {
      light: '#555e6c',
      main: '#0a00ff',
      dark: '#1e2532',
      contrastText: '#ffffff'
    },
    danger: {
      light: '#c944dd',
      main: '#eb196e',
      dark: '#b20000',
      contrastText: '#ffffff'
    },
    background: {
      default: '#ffffff',
      primary: '#030530',
      secondary: '#000000'
    },
    text: {
      primary: '#ffffff',
      secondary: '#000000'
    },
  },
  custom: {
    palette: {
      green: '#82de4c',
      red: '#eb196e',
      blue: '#002168',
      lightBlue: '#005571',
      purple: '#3a3391',
      pink: '#c944dd',
      grey: '#f4f4f4',
      darkGrey: '#c2c2c2',
      orange: '#da532c',
      hover: '#4a90e2',
      border: '#dee2e5'
    },
    layout: {
      topAppBarHeight: 70,
      maxDesktopWidth: 1140,
      drawerWidth: 240
    }
  }
}));

export default theme;